module.exports = __webpack_public_path__ + "img/deepseek-logo@2x.578d04b8.png";